import { useState } from "react";
import { Eye, UserCog, HardHat, Briefcase, User, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ROLES = [
  { key: "admin", label: "Admin", email: "demo@progere.ca", icon: UserCog },
  { key: "foreman", label: "Contremaître", email: "contremaitre@progere.ca", icon: HardHat },
  { key: "project_manager", label: "Chargé de projet", email: "charge@progere.ca", icon: Briefcase },
  { key: "employee", label: "Employé", email: "employe@progere.ca", icon: User },
];

export default function DemoBar() {
  const { user, login, logout } = useAuth();
  const [busy, setBusy] = useState("");
  const isDemo = typeof window !== "undefined" && localStorage.getItem("pp_demo") === "1";
  if (!isDemo || !user) return null;

  const switchRole = async (r) => {
    if (r.key === user.role) return;
    setBusy(r.key);
    try {
      localStorage.setItem("pp_demo", "1");
      await login(r.email, "Demo123!");
      window.location.href = "/tableau";
    } catch { setBusy(""); }
  };

  const exit = () => { logout(); window.location.href = "/"; };

  return (
    <div className="demo-bar" data-testid="demo-bar">
      <div className="demo-bar-label"><Eye size={15} /> <span>Mode démo — explorez les accès par rôle :</span></div>
      <div className="demo-bar-roles">
        {ROLES.map((r) => {
          const Icon = r.icon;
          const active = r.key === user.role;
          return (
            <button key={r.key} className={`demo-role-btn ${active ? "active" : ""}`} disabled={busy === r.key}
              onClick={() => switchRole(r)} data-testid={`demo-role-${r.key}`}>
              <Icon size={14} /> {r.label}
            </button>
          );
        })}
      </div>
      <button className="demo-exit" onClick={exit} data-testid="demo-exit"><X size={14} /> Quitter</button>
    </div>
  );
}
